import { render, staticRenderFns } from "./datatable-test.vue?vue&type=template&id=621e77a4&scoped=true&"
import script from "./datatable-test.vue?vue&type=script&lang=js&"
export * from "./datatable-test.vue?vue&type=script&lang=js&"
import style0 from "./datatable-test.vue?vue&type=style&index=0&id=621e77a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621e77a4",
  null
  
)

export default component.exports